<template>
  <!-- 市场概况 -->
  <div class="marketOverview">
    <el-tabs v-model="activeColumn" type="border-card" class="tabs-card-one">
      <el-tab-pane name="one" label="业绩统计">
        <performanceStatistics></performanceStatistics>
      </el-tab-pane>
      <el-tab-pane name="two" label="市场情绪">
        <marketStatistics></marketStatistics>
      </el-tab-pane>
      <el-tab-pane name="three" label="市场风格">
        <marketStyle></marketStyle>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import performanceStatistics from "./performanceStatistics.vue"
import marketStatistics from "./marketStatistics.vue"
import marketStyle from "./marketStyle.vue"

export default {
  name: "marketOverview",
  components: {
    performanceStatistics,
    marketStatistics,
    marketStyle,
  },
  data () {
    return {
      activeColumn: 'one',
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
</style>